import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_HIDDEN_ATTRIBUTE,
} from '../../constants/block-background-attributes';
import { BACKGROUND_HIDDEN } from '../../constants/display-options';

const shouldUseCachedDestinationBlock = ({
  cachedDestinationBlockNode,
  destinationBlockNode,
  displayOptions,
}) => {
  if (!cachedDestinationBlockNode || !destinationBlockNode) {
    return false;
  }

  const backgroundHiddenOption = displayOptions.find(({ id }) => id === BACKGROUND_HIDDEN);
  const withDisabledBackgroundHiddenOption =
    backgroundHiddenOption && !backgroundHiddenOption.isEnabled;
  const hasBackgroundImageValue =
    Boolean(destinationBlockNode.getAttribute(BACKGROUND_IMAGE_ATTRIBUTE)) &&
    !destinationBlockNode.hasAttribute(BACKGROUND_HIDDEN_ATTRIBUTE);
  const shouldRevertCachedBackgroundImage =
    withDisabledBackgroundHiddenOption && hasBackgroundImageValue;

  if (shouldRevertCachedBackgroundImage) {
    return false;
  }

  return true;
};

export default shouldUseCachedDestinationBlock;
